import { render } from "./DistributorInvoices.vue?vue&type=template&id=6dadfb26&scoped=true"
import script from "./DistributorInvoices.vue?vue&type=script&lang=js"
export * from "./DistributorInvoices.vue?vue&type=script&lang=js"

import "./DistributorInvoices.vue?vue&type=style&index=0&id=6dadfb26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dadfb26"]])

export default __exports__